export { default as LoginRegisterModal } from "src/molecules/LoginRegisterModal/LoginRegisterModal";
